import ListTreeIcon from '@liquidweb-dev/undercurrent/icons/lucide/ListTree';
import Label from 'components/ServersList/ServerDetails/Label';
import ServerListDetailBox from 'components/ServersList/ServersListDetailBox';

export interface ChildServerCountProps {
	numberOfChildServers: number;
}

/** How many child servers a private cloud parent has, shown on its row. */
const ChildServerCount = ({ numberOfChildServers }: ChildServerCountProps) => (
	<ServerListDetailBox sx={({ size }) => ({ minWidth: size.lg })}>
		<ListTreeIcon
			sx={({ size }) => ({
				height: size.xS,
				width: size.xS,
				flexShrink: 0,
			})}
		/>
		<Label>
			{numberOfChildServers} {numberOfChildServers === 1 ? 'server' : 'servers'}
		</Label>
	</ServerListDetailBox>
);

export default ChildServerCount;
